import {Injectable} from '@angular/core'
import { ungzip  } from "pako";
import { decode } from 'querystring';
import { TextDataResponse } from '../../common/model/TextDataResponse'

@Injectable({
    providedIn: 'root'
})
export class Utility{
    constructor(){
    }

    //Converting this into a wrapper method. So that other components won't have to change.
    decompressData(data: TextDataResponse) : string
    {
        return this.decompressTextData(data.text);
    }

    //In some cases we can't generate a TextDataResponse object in backend (ex. GetJobOutBlock response). 
    //In those cases, we will directly call this decompressTextData() with string input, instead of calling above wrapper.
    decompressTextData(data: string): string {

        var gezipedData = atob(data);
        const gzipedDataArray = Uint8Array.from(gezipedData, c => c.charCodeAt(0))
        var ungzipedData = ungzip(gzipedDataArray);
        var decodedData = new TextDecoder().decode(ungzipedData);
        return decodedData;
    }
}